import { render } from "./FadeIn.vue?vue&type=template&id=f20a3888&scoped=true"
const script = {}

import "./FadeIn.vue?vue&type=style&index=0&id=f20a3888&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f20a3888"]])

export default __exports__